<div class="modal-header">
  <h4 class="modal-title">
    {{ 'USER_FORM_REDIRECT_MODAL.TITLE' | translate }}
  </h4>
</div>

<div class="modal-body">
  @if (forceAddressEdit) {
    <p>
      {{ 'USER_FORM_REDIRECT_MODAL.ADDRESS_NOT_COMPLETE' | translate }}
    </p>
  }
  <p
    [innerHTML]="'USER_FORM_REDIRECT_MODAL.ADDRESS_EDIT_MESSAGE' | translate"
  ></p>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-color-from-db"
    (click)="redirectToEditUserForm()"
  >
    {{ 'YES' | translate }}
  </button>
</div>
